/**
 * Created by ptdave on 6/25/17.
 */

import {Pipe, PipeTransform} from '@angular/core';
import {StaffService} from '../../services/staff.service';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {StaffDto} from '@sidr/dto-types';

@Pipe({
  name: 'staffId'
})
export class StaffIdPipe implements PipeTransform {
  constructor(private staffService: StaffService) {
  }

  format(s: StaffDto): string {
    if (s?.displayName?.trim().length > 0) {
      return `${s.displayName} (${s.email})`;
    } else {
      return '(' + (s?.email || 'Unknown') + ')';
    }
  }

  transform(value: string, ...args: any[]): Observable<string> {
    if (!value || value.trim() === '') {
      return of('');
    }

    // Always return an Observable with proper error handling
    return this.staffService.get(value).pipe(
      map(staff => {
        if (!staff) {
          return 'Unknown Staff';
        }
        if (staff.displayName?.trim()) {
          return staff.displayName;
        }
        if (staff.firstName || staff.lastName) {
          return `${staff.lastName || ''}, ${staff.firstName || ''}`.trim();
        }
        return staff.email || 'Unknown Staff';
      }),
      catchError(error => {
        console.warn('Error fetching staff with ID:', value, error);
        return of('Unknown Staff');
      })
    );
  }
}
